import { PASSWORD_LENGTH } from '../../lengths'

export const messages_pt = {
  brio_inc: 'Brio Incorporadora',
  youMustBeACustomer: 'Para usar o app, você precisa ter feito a aquisição de um imóvel através da',

  //Bottom tab bar navigation titles
  bottomTabBar_tab1: 'Tab 1',
  bottomTabBar_tab2: 'Tab 2',

  header_backTitle: 'Voltar',

  //Appointments
  appointments_addressLabel: 'Endereço:',
  appointments_appointmentsTitle: 'Agenda',
  appontments_cancelLabel: 'Cancelar evento',
  appointments_confirm: 'Confirmar',
  appointments_confirmed: 'Confirmado',
  appointments_couldNotConfirmPresence: 'Não foi possível confirmar sua presença no evento, tente novamente!',
  appointments_couldNotDeclinePresence: 'Não foi possível confirmar sua ausência no evento, tente novamente!',
  appointments_couldNotRespondToEvent:
    'Não foi possível confirmar sua presença ou ausência no evento, tente novamente!',
  appointments_dateLabel: 'Data:',
  appointments_dialogButtonConfirm: 'Não',
  appointments_dialogButtonDismiss: 'Sim',
  appointments_iWontGo: 'Não irei',
  appointments_keysDeliveryCancelDialog:
    'Você selecionou "não irei” no evento de entrega de chaves. Para marcar uma nova data para a entrega, será necessário que você entre em contato com nosso SAC. Deseja fazê-lo agora?',
  appointments_joinTheRaffle: 'Entrar no sorteio',
  appointments_keysDeliveryContactUs: 'Caso você não possa comparecer, entre em contato com o nosso SAC',
  appointments_keysDeliveryTitleLabel: 'Entrega de chaves',
  appointments_keysDeliveryWhatsAppMessage:
    'Olá brio. Gostaria de marcar uma nova data para fazer a retirada das chaves. \n {constructionName}',
  appointments_leaveTheRaffle: 'Sair do sorteio',
  appointments_noAppointments: 'Você não possui nenhuma visita agendada.',
  appointments_noRaffles: 'Não existe nenhum sorteio disponível para você neste momento.',
  appointments_raffleToVisitConstructionLabel: 'Sorteio para visita à obra',
  appointments_raffleToVisitConstructionEnterprise: 'Empreendimento:',
  appointments_raffleToVisitConstruction_visitationDate: 'Data da visita:',
  appointments_raffleToVisitConstruction_raffleDate: 'Dia do sorteio:',
  appointments_rafflesTitle: 'Sorteios disponíveis',
  appointments_timeLabel: 'Horário:',
  appointments_visitationToConstructionTitleLabel: 'Visita à obra',
  appointments_visitationToConstructionSubtitle: 'Você foi contemplado (a) no sorteio para visita à obra!',
  appointments_visitationToConstructionCancelDialog:
    'Você confirma que não irá à visita agendada?\nEssa ação não poderá ser desfeita',
  appointments_visitationToConstructionConfirmationLimitDate: 'Você deve confirmar sua presença até o dia',
  appointments_visitationToConstructionConfirmedSuccessfully: 'Sua presença foi confirmada com sucesso!',
  appointments_youAlreadyEnrolledForTheRaffle: 'Você já se inscreveu para participar desse sorteio.',

  // Assistance screen
  assistance_actionButton_email: 'E-mail',
  assistance_actionButton_whatsapp: 'WhatsApp',
  assistance_appHeaderTitle: 'Atendimento',
  assistance_contactUsTitle: 'Deseja falar com a gente?',
  assistance_contactUs_phone: 'Contato 11 3003-4536',
  assistance_contactUs_businessHoursTitle: 'SAC brio - Horário de atendimento',
  assistance_contactUs_businessHours: `Segunda a Quinta: 9h às 18h.\nSexta: 9h às 17h.`,
  assistance_contactUs_disclaimer: 'Não há atendimento aos finais de semana e feriados.',

  assistance_frequentAskedQuestions_title: 'Dúvidas frequentes',
  assistance_frequentAskedQuestions_subtitle:
    'Tire suas dúvidas sobre como é o processo de financiamento e compra do seu imóvel com a Caixa e com a brio incorporadora.',

  assistance_technical_assistance_title: 'Assistência Técnica',
  assistance_technical_assistance_subtitle:
    'Precisa solicitar a assistência técnica no seu apartamento? Basta clicar aqui e preencher seus dados',
  assistance_technical_assistance_button: 'Solicitar',

  changePassword_currentPassword: 'Senha atual',
  changePassword_headerTitle: 'Alterar senha',
  changePassword_newPassword: 'Nova senha',
  changePassword_newPasswordAgain: 'Repetir nova senha',

  //Constructions
  constructions_documents_clientManual: 'Manual do cliente',
  constructions_documents_downloadError: 'Não foi possível baixar o arquivo, tente novamente.',
  constructions_documents_downloadFilePathPrefix: '/Brio-doc_',
  constructions_documents_downloadLoading: 'Baixando arquivo...',
  constructions_documents_blueprintWithMeasures: 'Plantas',
  constructions_documents_downloadsTitle: 'Downloads',
  constructions_documents_implantation: 'Implantação do empreendimento',
  constructions_documents_memorial: 'Memorial descritivo',
  constructions_documents_noDocs: 'Não existem documentos disponíveis para download.',
  constructions_headerTitle: 'Meu Lar',
  constructions_media_imagesTitle: 'Imagens',
  constructions_media_noMedia: 'Nenhuma mídia foi adicionada',
  constructions_media_shareMessage: 'O meu sonho está se tornando realidade, veja você também!',
  constructions_media_videosTitle: 'Vídeo',
  constructions_monthSelectTitle: 'Selecionar mês',
  constructions_tabs_docs: 'Documentos',
  constructions_tabs_media: 'Fotos',
  constructions_tabs_progress: 'Obra',
  constructions_contact_button: 'Fale Conosco',
  constructions_contact_title: 'Com problemas ?',

  // Construction Module
  constructionModule_foundation: 'Fundação',
  constructionModule_structure: 'Estrutura',
  constructionModule_finishing: 'Acabamento',
  constructionModule_totalWork: 'Total da obra',
  constructionModule_workBegin: 'Início da obra:',
  constructionModule_finishForecast: 'Previsão de conclusão:',

  //Dashboard
  dashboard_bottomTabs_appointments: 'Agenda',
  dashboard_bottomTabs_assistance: 'Atendimento',
  dashboard_bottomTabs_constructions: 'Meu Lar',
  dashboard_bottomTabs_fin: 'Financeiro',
  dashboard_bottomTabs_notifications: 'Alertas',
  dashboard_bottomTabs_profile: 'Meus Dados',
  dashboard_constructionsStatus: 'Status da Obra: ',
  dashboard_constructionsStatus_inProgress: 'Em andamento',
  dashboard_dropdownHeaderTitle: 'Selecionar unidade',
  dashboard_emptyNotificationsList: 'Você não possui novas notificações!',
  dashboard_moreNotifications: 'Ir para notificações',
  dashboard_notifications: 'Você possui {notificationCount} notificações.',
  dashboard_realtyTitle: 'Imóvel: ',
  dashboard_snackbarMessage: 'Notificação removida.',
  dashboard_undoLabel: 'Desfazer',

  downloadNeedsAccessGrant: 'Não foi possível obter a permissão para baixar esse arquivo no seu dispositivo.',

  enterpriseSelection_defaultMessage: 'Selecione um empreendimento',

  event_DateTime_hour: 'h',
  event_DateTime_separator: 'às',

  // General Error Messages
  error_changePassword_incorrectCurrentPassword: 'A senha atual está incorreta.',
  error_CPFMissing: 'CPF é um campo obrigatório',
  error_currentPassword: 'Senha atual incorreta',
  error_differentPasswords: 'As senhas não combinam',
  error_duplicateKey: 'Matrícula KOF ou e-mail já estāo sendo utilizados.',
  error_emailFormat: 'Digite um e-mail válido.',
  error_emailMissing: 'E-mail é um campo obrigatório!',
  error_invalidCPF: 'O formato de CPF inserido é inválido',
  error_invalidPassword: 'Senha inválida.',
  error_inputValidationError: 'A nova senha nāo deve ser igual à senha atual',
  error_logout: 'Não foi possível fazer logout. Tente novamente.',
  error_passwordChange: 'Não foi possível alterar a senha, verifique sua senha atual e tente novamente.',
  error_passwordMinLength: `A senha deve conter no mínimo ${PASSWORD_LENGTH} caracteres.`,
  error_passwordMissing: 'Senha é um campo obrigatório',
  error_passwordRecovery: 'Erro ao recuperar senha. Tente novamente mais tarde.',
  error_passwordRedefinition: 'Erro ao redefinir senha. Tente novamente mais tarde.',
  error_sequentialPassword: 'A senha nāo deve conter todos os dígitos em sequência crescente ou descrescente.',
  error_signIn: 'Falha ao realizar login. Tente novamente.',
  error_userNotFound: 'Usuário inexistente ou inválido.',
  error_snackbar_generic: 'Não foi possível realizar esta ação. Tente novamente mais tarde.',
  error_loadingInfo: 'Não foi possível carregar as informações.',
  error_userNotHaveConstruction: 'Nenhum empreendimento cadastrado para esse CPF',

  finance_headerTitle: 'Financeiro',
  finance_tabs_billsTitle: 'Boletos',
  finance_tabs_futureTitle: 'Futuro',

  // Finance Bills Screen
  financeBillsScreen_dialog_title: 'Boleto indisponível',
  financeBillsScreen_dialog_description:
    'Para solicitar o adiantamente de 4 ou mais parcelas, entre em contato com nosso SAC.',
  financeBillsScreen_dropdown_title: 'Selecione o empreendimento',
  financeBillsScreen_button_duplicate: '2ª via',
  financeBillsScreen_button_pay: 'Pagar',
  financeBillsScreen_button_download: 'Baixar',
  financeBillsScreen_totalPaid: 'Total pago',
  financeBillsScreen_modal_title: 'Atenção',
  financeBillsScreen_modal_error_generate_billet:
    'Ocorreu um erro ao gerar seu(s) boleto(s). Entre em contato com o nosso SAC para solicitar uma nova via.',
  financeBillsScreen_dialog_warning_interest_title: 'Atenção',
  financeBillsScreen_dialog_warning_interest_description:
    'Boletos vencidos terão a cobrança de 1% de juros ao mês e multa de 2% ao dia após o 1º dia do vencimento',

  // Finance Duplicate Screen
  financeDuplicateScreen_headerTitle: 'Solicitar 2ª via',
  financeDuplicateScreen_selectInstallment: 'Selecione a(s) parcela(s)',
  financeDuplicateScreen_sendToSAC: 'Enviar para SAC',
  financeDuplicateScreen_whatsApp_message: 'Olá Brio, gostaria de emitir a 2ª via da ',
  financeDuplicateScreen_whatsApp_message_and: ' e ',

  // Finance Future Screen
  financeFutureScreen_emptyState_title: 'Parcelas',
  financeFutureScreen_button_anticipateInstallment: 'Adiantar parcela',
  financeFutureScreen_dialog_title: 'Adiantar parcela',
  financeFutureScreen_dialog_unable:
    'Para solicitar o adiantamente de 4 ou mais parcelas, entre em contato com nosso SAC.',
  financeFutureScreen_dialog_message: `Lembrando que o boleto será gerado com o vencimento para 2 dias úteis`,
  financeFutureScreen_anticipateInstallment_header: 'Adiantar parcela',
  financeFutureScreen_sendToSAC: 'Enviar para SAC',
  financeFutureScreen_addValue: 'Adicione o valor',
  financeFutureScreen_payPartialValue: 'Pagar valor parcial',
  financeFutureScreen_paymentDate: 'Data de pagamento',
  financeFutureScreen_dropdown_title: 'Selecione o empreendimento',
  financeFutureScreen_selectInstallment: 'Selecione a(s) parcela(s)',
  financeFutureScreen_whatsApp_message: 'Olá brio, gostaria de solicitar o adiantamento de parcela.\n',
  financeFutureScreen_whatsApp_message_and: '\ne\n',
  financeFutureScreen_loadingNewFutureBillets: 'Seu boleto está saindo do forno',

  // Finance Pay Installment Screen
  financePayInstallmentScreen_headerTitle: 'Pagar parcela',
  financePayInstallmentScreen_button_download: 'Download do boleto',
  financePayInstallmentScreen_button_genereteBillet: 'Gerar boleto',
  financePayInstallmentScreen_button_copyCode: 'Copiar código',
  financePayInstallmentScreen_conditionType: 'Tipo de condição',
  financePayInstallmentScreen_dueDate: 'Data de vencimento',
  financePayInstallmentScreen_interestPercent: 'Juros contratuais',
  financePayInstallmentScreen_originalValue: 'Valor do título',
  financePayInstallmentScreen_fineValue: 'Valor de multa',
  financePayInstallmentScreen_payedValue: 'Valor abatido',
  financePayInstallmentScreen_total: 'Total',
  financePayInstallmentScreen_month: 'mês',
  financePayInstallmentScreen_barCode: 'Código de barras',
  financePayInstallmentScreen_snackbar_copy: 'O código de barras foi copiado com sucesso',
  financePayInstallmentScreen_generete_billet: 'Boleto vencido, por favor gere outro',

  // Finance Screen
  financeScreen_installments: 'Parcelas',
  financeScreen_emptyState_message: 'Você não possui parcelas',
  financeScreen_dialogButton_cancel: 'Cancelar',
  financeScreen_dialogButton_request: 'Solicitar',
  financeScreen_installmentType_future: 'futuras',
  financeScreen_installmentType_paid: 'pagas',
  financeScreen_installmentType_expired: 'vencidas',
  financeScreen_installmentType_open: 'a vencer',
  financeScreen_error_second_bank_slip: 'Error ao gerar o boleto, tente novamente mais tarde',
  financeScreen_error_second_bank_slips: 'Error ao gerar os boletos de : {date}, por favor tente novamente mais tarde',

  //First Login Screen
  firstLoginScreen_changePasswordButtonTitle: 'Alterar senha provisória',
  firstLoginScreen_headTitle: 'O sonho da casa própria acaba de começar!',
  firstLoginScreen_changeLaterButtonTitle: 'Alterar mais tarde',
  firstLoginScreen_subTitle:
    'Parabéns! A Brio Incorporadora tem muito orgulho e muita felicidade em participar deste sonho junto com você!',

  //Forgot Password Screen
  forgotMyPassword_title: 'Esqueci minha senha',

  // Login Screen
  loginScreen_enter: 'Entrar',
  loginScreen_forgotMyPassword: 'Esqueci minha senha',
  loginScreen_cpf: 'CPF do Titular',
  loginScreen_password: 'Senha',
  loginScreen_contactUS: 'Fale Conosco',
  loginScreen_snackbar_invalidCPF: 'Número de CPF não cadastrado.',
  loginScreen_snackbar_invalidPassword: 'Senha inválida. Por favor, digite novamente.',
  loginScreen_snackbar_unknownError: 'Ocorreu um erro desconhecido, tente novamente mais tarde',

  //month list for Constructions Media
  month_january: 'Janeiro',
  month_february: 'Fevereiro',
  month_march: 'Março',
  month_april: 'Abril',
  month_may: 'Maio',
  month_june: 'Junho',
  month_july: 'Julho',
  month_august: 'Agosto',
  month_september: 'Setembro',
  month_october: 'Outubro',
  month_november: 'Novembro',
  month_december: 'Dezembro',

  // Notifications Screen
  notificationsScreen_header: 'Notificações',
  notificationsScreen_emptyCard_title: 'Novas mensagens',
  notificationsScreen_emptyCard_message: 'Você não possui novas mensagens',
  notificationsScreen_type_newConstructionMedia: 'Novas fotos foram adicionadas ao Módulo de Obras!',
  notificationsScreen_type_finishedConstruction: 'Parabéns! A obra acabou de ser finalizada!',
  notificationsScreen_type_newInstallment: 'Novo boleto de pagamento disponível no Módulo Financeiro.',
  notificationsScreen_type_latePayment:
    'Seu boleto está atrasado. Acesso o Módulo Financeiro para acessar sua Segunda Via.',
  notificationsScreen_type_paymentReceived: 'Seu pagamento foi efetuado com sucesso!',
  notificationsScreen_type_visitEventOpen:
    'Sorteio para visitar a obra disponível! Acesse a área de Agendamentos para saber mais.',
  notificationsScreen_type_wasDrawn:
    'Você foi contemplado (a) no sorteio para visitar a obra! Confirme sua presença em Agendamentos.',
  notificationsScreen_type_wasNotDrawn: 'Você não foi contemplado (a) no sorteio para visitar a obra!',
  notificationsScreen_type_constructionStatusUpdate: 'Status da obra atualizado! Confira no Módulo de Obras.',
  notificationsScreen_type_closeDueDate_installmentExpires:
    'Seu boleto tem vencimento próximo e está disponível no Módulo Financeiro.',
  notificationsScreen_type_visitScheduling_date: 'A sua visita à obra foi agendada. Confira detalhes em Agenda.',
  notificationsScreen_type_deliveryKeysSchedule_date:
    'Entrega de chaves foi agendada. Confirme sua presença em Agenda.',
  notificationsScreen_type_visitEventCanceled: 'Visita cancelada',
  notificationsScreen_type_cancelDeliveryKeysSchedule: 'Entrega de chaves cancelada',

  // Onboarding Screen
  onboardingScreen_goToHome_button: 'Ir para home',
  onboardingScreen_skip_button: 'Pular',
  onboardingScreen_continue_button: 'Continuar',
  onboardingScreen_welcome_title: 'Parabéns pela sua compra!',
  onboardingScreen_welcome_text:
    'Estamos felizes em fazer parte desse sonho. Conheça as vantagens em estar utilizando o app da Brio Incorporadora',
  onboardingScreen_financing_name: 'Financimento',
  onboardingScreen_financing_title: 'Módulo de financiamento',
  onboardingScreen_financing_text:
    'Neste módulo, você pode acompanhar o progresso do financiamento e obter seu boleto de pagamento direto pelo celular',
  onboardingScreen_construction_name: 'Obras',
  onboardingScreen_construction_title: 'Módulo de obras',
  onboardingScreen_construction_text:
    'Saiba exatamente como está o progresso da obra e receba imagens e vídeos para compartilhar',
  onboardingScreen_notification_name: 'Notificações',
  onboardingScreen_notification_title: 'Notificações',
  onboardingScreen_notification_text:
    'Receba notificações sobre o status da obra, datas de sorteios para visitas ou vencimento dos boletos',

  //Profile Screen
  profileScreen_aboutBrio: 'Sobre a Brio',
  profileScreen_aboutBrio_fullText:
    'O sonho de construir. A brio incorporadora foi criada com objetivo de idealizar, projetar e entregar produtos de alto valor agregado. O nome da empresa reflete os valores e a forma de trabalho de nossos sócios e colaboradores.\n\n' +
    'Buscamos atender e superar as expectativas dos nossos clientes, através do comprometimento de entrega dos condomínios com pontualidade, qualidade e potencial de valorização.\n\n' +
    'A equipe brio incorporadora é formada por profissionais experientes e com um vasto histórico de empreendimentos entregues. Seus sócios atuaram em grandes empresas do setor de incorporação e construção civil, participando da fundação e do crescimento de importantes empresas da região de Ribeirão Preto.',
  profileScreen_aboutBrio_mission:
    'Viabilizar o sonho do imóvel próprio através da concepção de condomínios com alto valor agregado com um custo acessível ao nosso cliente.',
  profileScreen_aboutBrio_missionTitle: 'Missão',
  profileScreen_aboutBrio_values:
    '» Humildade, disciplina e ética em nossas ações;\n\n' +
    '» Busca incansável por melhores resultados estimulando a meritocracia com os colaboradores;\n\n' +
    '» Cultura empresarial baseada na formação de colaboradores com potencial de superar as expectativas dos nossos clientes;\n\n' +
    '» Delegação planejada e descentralização de nossas atividades empresariais, contribuindo para o crescimento e continuidade da brio incorporadora.',
  profileScreen_aboutBrio_valuesTitle: 'Valores',
  profileScreen_aboutBrio_vision:
    'Tornar-se padrão de excelência na idealização e entrega de empreendimentos imobiliários.',
  profileScreen_aboutBrio_visionTitle: 'Visão',
  profileScreen_activateNotifications: 'Ativar notificações',
  profileScreen_changeName: 'Mudar nome social',
  profileScreen_changeName_error: 'Não foi possível alterar seu nome, por favor tente novamente.',
  profileScreen_changeName_success: 'Nome alterado com sucesso!',
  profileScreen_changeName_nameLabel: 'Nome social',
  profileScreen_changePassword: 'Alterar senha',
  profileScreen_enterpriseLabel: 'Empreendimentos',
  profileScreen_headerTitle_label: 'Perfil',
  profileScreen_privacyPolicy: 'Políticas de privacidade',
  profileScreen_privacyPolicy_fullText:
    '﻿Contrato e seus Termos e Condições de Uso BRIO \n' +
    '\n' +
    'Nós da família BRIO  damos as boas-vindas a você “CLIENTE” que a partir da presente data, declara, para todos os fins de direito que conhece e concorda integralmente com os Termos e Condições aqui descritas, bem como nossa Política de Privacidade “TERMOS”, ao se cadastrar em um dos nossos aplicativos para utilização da nossa plataforma de “SERVIÇOS”, certificando que  li e entendi integralmente os “TERMOS”, consistindo nesse presente  “CONTRATO” firmado entre a “BRIO ” e o “CLIENTE” após a manifestação do “ACEITE” do presente “CONTRATO” e todos os seus “TERMOS”.\n' +
    '\n' +
    'Somente após manifestação do “ACEITE” do presente “CONTRATO” e todos os seus “TERMOS”, o “CLIENTE” poderá utilizar os nossos serviços, os quais poderão ser utilizados através do “WEBSITE” www.brioincorporadora.com.br e/ou  do “APLICATIVO” BRIO  disponível na Apple App Store,  Android, no Google Play e no Windows Phone Store.\n' +
    '\n' +
    'O “ACEITE” do presente “CONTRATO” e todos os seus “TERMOS” somente será válido e regular para pessoas capazes juridicamente e que concorde integralmente com o aqui estabelecido, vinculando jurídica e legalmente o “CLIENTE” aos nossos “SERVIÇOS”, utilizando ou não dos mesmos.\n' +
    '\n' +
    ' A BRIO, se resguarda no direito de realizar alterações/atualizações do presente “CONTRATO” e todos os seus “TERMOS”, a qualquer momento, sem aviso prévio e a simples utilização do \t“APLICATIVO” após alteração/atualização do “CONTRATO” e todos os seus “TERMOS” importa na integral, ampla e irrestrita anuência e concordância do seu novo conteúdo. Caso o “CLIENTE” não concorde com as alterações, deverá cancelar sua conta, e cessar toda e qualquer utilização do “APLICATIVO”. Na ausência de manifestação contrária,  entender-se-á que o “CLIENTE” aceitou tacitamente o “CONTRATO” e todos os seus “TERMOS”,  vinculando jurídica e legalmente o “CLIENTE” aos nossos “SERVIÇOS”, utilizando ou não dos mesmos.\n' +
    '\n' +
    'Ao assinar o presente termo, o “CLIENTE”  consente e concorda que a empresa BRIO, ou quaisquer uma das empresas do seu grupo,  tome decisões referentes ao tratamento de seus dados pessoais, bem como realize o tratamento de seus dados, envolvendo operações como as que se referem a coleta, produção, recepção, classificação, utilização, acesso, reprodução, transmissão, distribuição, processamento, arquivamento, armazenamento, eliminação, avaliação ou controle da informação, modificação, comunicação, transferência, difusão ou extração.\n' +
    '\n' +
    'Quanto ao Cadastro\n' +
    '\n' +
    'O “CLIENTE” que deseje utilizar o “APLICATIVO”, necessita, prévia e  obrigatoriamente preencher todos  os campos de cadastro, fornecendo  informações válidas, corretas e fidedignas, através do “WEBSITE” www.brioincorporadora.com.br e/ou  do “APLICATIVO” BRIO  disponível na Apple App Store,  Android, no Google Play e no Windows Phone Store, sendo imprescindível o “ACEITE” do presente “CONTRATO” e todos os seus “TERMOS”, bem como a confirmação de seu número telefônico, pois, enquanto não confirmado o número,  a utilização do “APLICATIVO”  estará  bloqueada até a efetivação da confirmação.\n' +
    '\n' +
    'O “CLIENTE” é o único e integral responsável pelas informações fornecidas, as quais,  caso acarretarem danos ou prejuízo de qualquer espécie, sanções legais podem ser tomadas pela BRIO  a fim de resguardar seus interesses e a integridade dos outros “CLIENTE” do sistema.\n' +
    '\n' +
    'Quanto aos “SERVIÇOS”\n' +
    '\n' +
    'Pela plataforma os “CLIENTES”, estabelecerão negócios jurídicos não proibidos por lei, prestado única e exclusivamente por particulares, consistentes nas plataformas de “SERVIÇOS”, otimizando e intermediando a implementação e efetivação desses negócios jurídicos entre os nossos “CLIENTES”.\n' +
    '\n' +
    'Pela plataforma, a BRIO permite que “CLIENTE” crie seu perfil de usuário e cliente, para ter acesso a sua situação financeira e cadastral, acompanhar sua obra, abrir chamado para assistência técnica, entre outras funcionalidades.\n' +
    '\n' +
    'Após a realização dessas ações entendemos que você está de acordo com a coleta de dados para serem utilizados pela nossa empresa, já que você os informou, por livre e espontânea vontade. \n' +
    '\n' +
    'Da Política de Privacidade\n' +
    '\n' +
    'A BRIO  pode recolher, gravar e utilizar em conexão com outros sites e parceiros as informações pessoais do  “CLIENTE”, incluindo, mas não se limitando a, nome, foto, endereço, número de telefone, interesses, atividades, sexo e idade.\n' +
    '\n' +
    'A BRIO  se resguarda no direito de gravar seu IP, tipo de navegador, aparelho e operadora de celular, posição geográfica e outros dados.\n' +
    '\n' +
    'A BRIO  não divulga publicamente nem a terceiros suas informações de modo que possam identificá-lo, mas pode fazê-lo de forma agregada no intuito de realizar análises, estudos, melhoria do sistema e por força de ordem judicial.\n' +
    '\n' +
    ' A BRIO  está fortemente comprometida em manter a sua privacidade quando estiver visitando o nosso site. Algumas das informações mantidas no nosso servidor são informações que o “CLIENTE” se prontifica a fornecer através de formulários, enquanto que algumas são obtidas automaticamente. A menos que o próprio  “CLIENTE” se prontifique a apresentar dados pessoais, a BRIO  nunca coletará informações com base nas quais  “CLIENTES” possam ser identificado\n' +
    '\n' +
    'A BRIO  adotará todas as medidas suficientemente necessárias para garantir que seus dados sejam tratados com segurança e de acordo com esta Política de Privacidade, visando que inexistência de quaisquer transferências de seus Dados Pessoais, sem o seu consentimento,  buscando a maior segurança de seus dados e outras informações pessoais.\n' +
    '\n' +
    'Em conformidade com Lei Geral de Proteção de Dados (LGPD) e GDPR, este aplicativo  usa cookies para melhorar e personalizar sua experiência em nosso aplicativo e com nossos conteúdos e anúncios.\n' +
    '\n' +
    'A BRIO responsabiliza-se pela manutenção de medidas de segurança, técnicas e administrativas aptas a proteger os dados pessoais de acessos não autorizados e de situações acidentais ou ilícitas de destruição, perda, alteração, comunicação ou qualquer forma de tratamento inadequado ou ilícito. \n' +
    '\n' +
    'Em conformidade ao art. 48 da Lei nº 13.709, a BRIO comunicará o “CLIENTE” e à Autoridade Nacional de Proteção de Dados (ANPD) a ocorrência de incidente de segurança que possa acarretar risco ou dano relevante.\n' +
    '\n' +
    'Das Informações Automaticamente Coletadas e Armazenadas\n' +
    '\n' +
    'O “Servidor” da BRIO coleta automaticamente informações não pessoais. As informações normalmente coletadas incluem o nome de domínio de seu provedor de acesso à internet, o endereço do protocolo de internet (IP) utilizado para conectar o computador do “CLIENTE” à internet, o tipo e versão do browser do “CLIENTE”, o sistema operacional e plataforma, o tempo médio gasto no “APLICATIVO”, as páginas visitadas, as informações procuradas, os horários de acesso e outras estatísticas relevantes. A BRIO  emprega todas essas informações para mensurar o uso de seu site e/ou aplicativo, bem como para administrá-los e aperfeiçoá-los.\n' +
    '\n' +
    'Algumas das páginas da BRIO  também podem depositar certas parcelas de informações, chamadas “cookies” (biscoitos), no computador do “CLIENTE”. De modo geral, um “cookie” cede um número único ao CLIENTE, número este que não tem nenhum significado fora do site cedente. Essa tecnologia não coleta informações identificadoras de um “CLIENTE”, apresentando tais informações apenas de forma global. Essa tecnologia e as informações oferecidas através dela têm por objetivo aperfeiçoar a navegação no “APLICATIVO” da BRIO . A maioria dos web browsers permite ao “CLIENTE” rejeitar ou aceitar a característica “cookie”. Entretanto, é importante notar que os cookies são necessários para lhe oferecer certas características (por exemplo, entrega customizada de informações) disponíveis no Website da BRIO. Para mais informações sobre os cookies, acessar http://www.microsoft.com/info/cookies.htm.\n' +
    '\n' +
    '\n' +
    'Das Informações pessoais a serem fornecidas pelo CLIENTE, a critério dele\n' +
    '\n' +
    'Para o recebimento de serviços personalizados, o “CLIENTE” terá de fornecer informações pessoais (tais como nome e endereço eletrônico). Nenhuma consequência significativa resultará de sua recusa em apresentar tais informações, exceto o fato de que o “CLIENTE” não poderá obter a funcionalidade ou receber as informações que vier a solicitar.\n' +
    '\n' +
    'Ao encaminhar os dados pessoais à BRIO , o “CLIENTE” será tratado como tendo dado sua permissão para o processamento de seus dados pessoais, conforme estabelecido nestes Termos.\n' +
    '\n' +
    'A BRIO somente utilizará informações pessoais para os fins que lhe forem indicados na ocasião do seu fornecimento.\n' +
    '\n' +
    'A BRIO não divulgará, venderá ou alugará essas informações de identificação pessoal a qualquer outra organização ou entidade, ou as permutará com elas, sem antes ter comunicado o “CLIENTE” e este ter dado seu consentimento expresso nesse sentido, ou conforme exigido por lei e por força de ordem judicial.\n' +
    '\n' +
    'A BRIO  reserva-se o direito de alterar a presente política a qualquer tempo. A política de privacidade não cria nenhum direito contratual ou outro direito legal com relação a qualquer parte ou em nome da mesma.',
  profileScreen_useTerms: 'Termos de Uso',
  // Push
  push_alert_title: 'Permissão',
  push_alert_message: 'Permitir que o App Brio envie notificações?',
  push_alert_allow: 'permitir',
  push_alert_deny: 'negar',

  //Recover Password Screen
  forgotPassword_actionButton: 'Continuar',
  forgotPassword_checkYourInbox: '\nVerifique seu e-mail na caixa de entrada ou spam.',
  forgotPassword_cpfLabel: 'CPF',
  forgotPassword_goToLogin: 'Ir para Login',
  forgotPassword_helpText: 'Não utilize pontos ou traços',
  forgotPassword_headerTitle: 'Recuperar Senha',
  forgotPassword_main: 'Enviaremos a sua senha',
  forgotPassword_passwordSent: 'Uma senha provisória foi enviada para o email cadastrado',
  forgotPassword_passwordSentTitle: 'Sua senha foi enviada',
  forgotPassword_pleaseProvideCpf: 'Por favor, insira seu CPF para continuar',
  forgotPassword_resendPassword: 'Reenviar Senha',
  forgotPassword_resendPassword_failure: 'Não foi possível re-enviar o e-mail, tente novamente!',
  forgotPassword_resendPassword_failure_userNotFound: 'Não existe um usuário com esse cpf, por favor cadastre-se',
  forgotPassword_resendPassword_success: 'E-mail re-enviado com sucesso!',
  forgotPassword_userNotFound: 'Usuário não cadastrado',
  forgotPassword_userNotFound_graphQLErrorMsg: "Couldn't find user",
  forgotPassword_tryAgain: 'Não foi possível recuperar a senha, tente novamente!',

  //Register Screen
  registerScreen_title: 'Fazer cadastro',

  //Redefine Password Screen
  redefinePassword_bodyText: 'Cadastre uma nova senha',
  redefinePassword_changePassword: 'Alterar Senha',
  redefinePassword_headerTitle: 'Redefinir Senha',
  redefinePassword_newPassword: 'Nova senha',
  redefinePassword_newPasswordAgain: 'Reescrever senha',
  redefinePassword_snackbar_differentPasswords: 'As senhas digitadas não conferem. Por favor, digite novamente.',
  redefinePassword_snackbar_success: 'Sua senha foi redefinida com sucesso!',

  //SignUp
  signUp_actionButtonLabel: 'Continuar',
  signUp_actionLabel: 'Cadastre-se',
  signUp_appHeaderTitle: 'Identificação',
  signUp_checkbox_1: 'Li e concordo com os ',
  signUp_checkbox_2: 'Termos de Uso ',
  signUp_checkbox_3: 'e ',
  signUp_checkbox_4: 'Política de Privacidade',
  signUp_cpfLabel: 'CPF',
  signUp_emailLabel: 'E-mail',
  signUp_error:
    'Não foi possível completar a requisição. Verifique seu e-mail e CPF e tente novamente ou entre em contato com o SAC',
  signUp_headerMain: 'Para usar o app, você precisa ter feito a aquisição de um imóvel através da ',
  signUp_headerSecondary: 'Brio Incorporadora',
  signUp_notRegisteredYet: 'Ainda não tem conta?',
  signUp_subtitle: 'Por favor, insira seu e-mail para continuar',

  signUpVerification_actionButtonTitle: 'Ir para login',
  signUpVerification_appHeaderTitle: 'Verificação',
  signUpVerification_description_line1: 'Um e-mail foi enviado para sua conta com uma senha provisória de acesso.',
  signUpVerification_description_line2: 'Verifique seu e-mail e efetue o login com a senha provisória enviada.',
  signUpVerification_title: 'Verifique seu e-mail',

  signUpContactUs_haveProblem: 'Com problemas?',
  signUpContactUs_button: 'Fale conosco',

  logoutPrompt: 'Por favor faça novamente o login.',
}
